module.exports = __webpack_public_path__ + "static/img/Emblem_of_India.5cda418f.png";